import { useLingui } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useDatabaseTranslation } from '@/services/i18n';

import { Item } from './Item';

export const ArticlePurchaseChannel = () => {
  const { t } = useLingui();
  const { _db } = useDatabaseTranslation();
  const { article } = useArticleContext();

  return (
    <Item
      label={t({ id: 'article.information.purchase-channel', message: 'Purchase channel' })}
      value={article.purchaseChannel ? _db(article.purchaseChannel) : undefined}
    />
  );
};
